import Swal from 'sweetalert2/dist/sweetalert2.js'

// Configura as opções padrões
const GSwal = Swal.mixin({
    buttonsStyling: false,
    customClass: {
        //change title color
        title: 'text-destaques text-xl p-2 mt-2',
        htmlContainer: 'text-secondary text-base',
        confirmButton:
            'rounded-full text-[16px] hover:bg-primary-green  bg-tertiary-green text-white min-w-40! px-5 pt-2 pb-2 max-md:w-full max-md:mb-2',
        cancelButton:
            'rounded-full text-[16px]  text-white rounded-full cursor-pointer min-w-40! bg-secondary/50 hover:bg-secondary max-md:mb-2 px-5 pt-2 pb-2 max-md:w-full md:mx-2',
        popup: 'z-999 rounded-3xl min-w-[300px] bg-white/95!',
        input: `border border-calm-gray-ultralight h-12! text-lg rounded-xl w-11/12 
              focus:outline-hidden  mx-auto 
              px-2.5 items-center flex 
              focus:border-calm-gray-ultralight text-secondary focus:ring-0`,
    },
})

export default GSwal
